<div class="spinner-container">
    <mat-spinner diameter="150" strokeWidth="10" color="primary"></mat-spinner>
</div>